"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AssetUpload = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _PermissionSetSelector = require("../Shared/PermissionSetSelector");

var _CategoriesSelector = require("../Shared/CategoriesSelector");

var _FileUpload = _interopRequireDefault(require("@civicplus/preamble/lib/FileUpload/FileUpload"));

var _AssetModifyMultiple = require("../AssetModify/Child/AssetModifyMultiple");

var _AssetModify = require("../AssetModify/AssetModify");

var AssetUpload = function AssetUpload(props) {
  var _useState = (0, _react.useState)(),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      set = _useState2[0],
      setSet = _useState2[1];

  var categories = (0, _react.useRef)([]);
  var files = (0, _react.useRef)([]);

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      uploaded = _useState4[0],
      setUploaded = _useState4[1];

  var onFilesDropped = function onFilesDropped(dropped) {
    files.current = dropped;
    setUploaded(true);

    if (props.onAssetsUploaded) {
      props.onAssetsUploaded(dropped);
    }
  };

  if (uploaded) {
    return files.current.length > 1 ? /*#__PURE__*/_react["default"].createElement(_AssetModifyMultiple.AssetModifyMultiple, {
      files: files.current,
      permissionSet: set,
      categories: categories.current,
      config: props.config,
      onAssetSaved: props.onAssetSaved
    }) : /*#__PURE__*/_react["default"].createElement(_AssetModify.AssetModify, {
      file: files.current[0],
      permissionSet: set,
      categories: categories.current,
      config: props.config,
      onPermissionSetChange: setSet,
      isNew: true,
      onAssetSaved: props.onAssetSaved
    });
  }

  return /*#__PURE__*/_react["default"].createElement("div", {
    id: props.id,
    className: "prmbl-assetUpload"
  }, /*#__PURE__*/_react["default"].createElement(_PermissionSetSelector.PermissionSetSelector, {
    isInDialog: props.isInDialog,
    config: props.config,
    onChange: setSet,
    isCreating: true,
    isAsset: true
  }), set && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_CategoriesSelector.CategoriesSelector, {
    config: props.config,
    value: [],
    onChange: function onChange(selected) {
      categories.current = selected;
    }
  }), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      marginTop: "1em"
    }
  }, /*#__PURE__*/_react["default"].createElement(_FileUpload["default"], {
    id: "file-upload-demo",
    onDrop: onFilesDropped
  }, "Click or drag to add file(s)..."))));
};

exports.AssetUpload = AssetUpload;